























import Vue from 'vue';
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    computed: {
        ...mapState('bh-flow', { showProperties: 'show', targetMod: 'module', onSave: 'handler', currentValue: 'value', timestamp: 'timestamp', itemChilds: 'child'}),
        ...mapGetters('esb', { getModule: 'get' })
    },
    methods: mapMutations('bh-flow', { hideProperties: 'hide' })
})
export default class BhFlowproperties extends Vue {
    @Prop({ default() { return {}; } })
    value: any;

    showProperties: any;
    targetMod: any;
    onSave: any;
    currentValue: any;
    getModule: any;
    hideProperties: any;

    loading = false;

    properties = {
        $name: ''
    };

    public save() {
        this.onSave(this.properties);
        this.hideProperties();
    }

    @Watch('timestamp')
    public async initialize() {
        this.loading = true;
        try {
            const mod = this.getModule(this.targetMod);
            this.properties = this.properties.$name || mod.name;
            this.properties = {
                $name: this.currentValue.$name || mod.name,
                ...this.currentValue
            }
        } catch(err) {
            console.log(err);
        } finally {
            this.loading = false;
        }
    }

    public generateTab(tabs: string[]) {
        return Object.keys({
            Basic: [],
            ...tabs
        });
    }
}
